var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.823 15.4896L10.9494 11.3435C12.393 10.1574 13.3191 8.39356 13.3191 6.42695C13.3191 2.88909 10.3366 0 6.65953 0C2.98249 0 0 2.88909 0 6.43709C0 9.98509 2.98249 12.8742 6.65953 12.8742C7.57198 12.8742 8.44358 12.6917 9.24708 12.3673L12.1751 16.5844C12.3658 16.8581 12.679 17.0101 13.0058 17.0101C13.1965 17.0101 13.4008 16.9595 13.5642 16.8378C14.0136 16.5337 14.1362 15.9356 13.823 15.4997V15.4896ZM2.00195 6.43709C2.00195 3.95349 4.0856 1.92606 6.65953 1.92606C9.23346 1.92606 11.3171 3.94335 11.3171 6.42695C11.3171 8.91055 9.21984 10.9278 6.65953 10.9278C4.09922 10.9278 2.00195 8.91055 2.00195 6.42695V6.43709Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.aa46f00bf9d8d6303d97fcd80e80d4bc.svg";
export { ForwardRef as ReactComponent };